var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#055A7F"}}),_c('path',{attrs:{"stroke":"#FFF","stroke-linecap":"round","stroke-width":"3","d":"M17 7l-7 10-4-3.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }